<template>
    <div class="page-header">
        <div class="form-row header-style">
            <div class="form-group col-md-2" style="margin:0px">
				<h3 class="form-group header-title" style="margin:0px">Notifications</h3>
            </div>


            <!-- <div class="form-group col-md-2">
                <select class="form-control brand-name" id="entityTypeFilter" v-model="selectedEntityTypeFilter" @change="getNotificationList()">
                    <option value="">--- All Entity Type ----</option>
                    <option value="ASIN">ASIN Scraper</option>
                    <option value="cg_overspending">Campaign Group Overspending</option>
                    <option value="cg_underspending">Campaign Group Underspending</option>
                </select>
            </div> -->
            <div class="form-group col-md-2" style = "margin:0px">
                <!-- <select class="form-control brand-name" id="lastXDays" v-model="selectedLastXDays" @change="getNotificationList()">
					<option value="365">All</option>
                    <option value="">Days</option>
                    <option value="7">Last 7 Days</option>
                    <option value="15">Last 15 Days</option>
                    <option value="30">Last 30 Days</option>
                </select> -->
				<multiselect
					v-model="selectedLastXDays"
					:options="dayList"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="name"
					:track-by="name"
					open-direction="bottom"
					:taggable="false"
					placeholder="Days"
					class="form-control multi-dropdown"
					selectLabel = ""
					selectedLabel = ""
					deselectLabel = ""
					@select = "getDayFilter($event)"
					@remove = "resetDayFilter()"
					/>
            </div>
            <div class="form-group col-md-2" style = "margin:0px">
	  			 <!-- <select
	  	  		  class="form-control brand-name"
	  	  		  id="brandFilter"
	  	  		  v-model="selectedVendor"
				  @change = "getNotificationList"
	  	  		>
	  	  		  <option value>All Vendors</option>
	  	  		  <option
	  	  			v-for="item in vendorsList"
	  	  			:key="item.name + '_' + item.id"
	  	  			:value="item.id"
	  	  		  >{{ item.name }}</option>
	  	  		</select> -->
				<multiselect
					v-model="selectedVendor"
					:options="vendorsList"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="name"
					:track-by="name"
					open-direction="bottom"
					:taggable="false"
					placeholder="All Vendors"
					class="form-control multi-dropdown"
					selectLabel = ""
					selectedLabel = ""
					@select = "getNotificationList"
					@remove = "resetFilter()"
					/>
            </div>
            <div class="form-group col-md-3"></div>
            <div class="form-group col-md-2 search-block" style = "margin: 0px;">
                <input type="search" class="form-control search" id="search"  @keyup.enter="searchData()" v-model="searchFilterString" placeholder="Entity Id"  />
            </div>
            <div class="form-group col-md-1 search-button" style="margin: 0px;">
            <button class="btn btn-primary " style="margin:0px !important" @click="searchData()">
                    <i class="fa fa-search"></i> Search
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";

export default {
    name: 'NotificationListGridHeader',
	components:{
		Multiselect
	},
    data() {
        return {
			selectedVendor:[],
			dayList :[
				// {id:"", name:"Days"},
				{id:"7", name:"Last 7 Days"},
				{id:"15", name:"Last 15 Days"},
				{id:"30", name:"Last 30 Days"},
				{id:"365", name:"Last 1 Year"}
			],
			selectedLastXDays:[]
        }
    },
    computed: {
		currentPageNumber: {
			set(val) {
				this.$store.state.currentPageNumber = val;
			},
			get() {
				return this.$store.state.currentPageNumber;
			}
		},
        // selectedVendor: {
        //     set(val) {
        //         this.$store.state.selectedVendorNotification = val
        //     },
        //     get() {
        //         return this.$store.state.selectedVendorNotification
        //     }
        // },
		vendorsList() {
			let data = this.$store.state.vendorList.filter(e=>e.name);
			if(data && data.length && data[0].id!="all")
				data.unshift({id:"all", name:"All Vendor"})
			return data
		},
        // selectedLastXDays: {
        //     set(val) {
        //         this.$store.state.selectedLastXDays = val
        //     },
        //     get() {
        //         return this.$store.state.selectedLastXDays
        //     }
        // },
        selectedEntityTypeFilter: {
            set(val) {
                this.$store.state.selectedEntityTypeFilter = val
            },
            get() {
                return this.$store.state.selectedEntityTypeFilter
            }
        },

        searchFilterString: {
            set(val) {
                if(!val){
					 this.$store.state.searchFilterString = val
					 this.getNotificationList()
                }
				else{
					 this.$store.state.searchFilterString = val
				}
            },
            get() {
                return this.$store.state.searchFilterString
            }
        },
        selectedSortOrder: {
            set(val) {
                this.$store.state.selectedSortOrder = val
            },
            get() {
                return this.$store.state.selectedSortOrder
            }
        },

    },
    methods: {
        getNotificationList(data) {
			this.currentPageNumber = 1
			if(data && data.id == "all"){
				this.resetFilter();
			}
			else if(data){
				this.$store.state.selectedVendorNotification = data.id
				this.$store.dispatch('notification/getNotificationList')
			}
			else{
				this.$store.dispatch('notification/getNotificationList')
			}
        },
		resetFilter(){
			this.currentPageNumber = 1
			this.$store.state.selectedVendorNotification = ""
			this.$store.dispatch('notification/getNotificationList')
		},
		getDayFilter(data){
			this.currentPageNumber = 1
			this.$store.state.selectedLastXDays = data.id;
			this.$store.dispatch('notification/getNotificationList')
		},
		resetDayFilter(){
			this.currentPageNumber = 1
			// this.selectedLastXDays = [{id:"", name:"Days"}]
			this.selectedLastXDays = []
			this.$store.state.selectedLastXDays = "";
			this.$store.dispatch('notification/getNotificationList')
		},
		searchData(){
			this.currentPageNumber = 1
			this.$store.dispatch('notification/getNotificationList')
		}
    }
}
</script>

<style lang="scss">

</style>
